const subpageNav = document.querySelector('.subpage-nav');

if (subpageNav) {
	const links = document.querySelectorAll('a.subpage-nav__link');
	let currentLink;

	// Intersection Observer options
	const options = {
		root: null,
		rootMargin: '0px',
		threshold: 0.5
	};

	// Callback function to be executed when intersection occurs
	const callback = (entries, observer) => {
		entries.forEach(entry => {
			const targetId = entry.target.getAttribute('id');
			const link = document.querySelector(`a.subpage-nav__link[href="#${targetId}"]`);

			if (entry.isIntersecting) {
				if (link) {
					link.classList.add('is-visible');
				}
			} else {
				if (link) {
					link.classList.remove('is-visible');
				}
			}
		});
	};

	// Create Intersection Observer instance
	const observer = new IntersectionObserver(callback, options);

	// Select all bookmark links
	const bookmarkLinks = document.querySelectorAll('a.subpage-nav__link[href^="#"]');

	// Observe each link's target
	bookmarkLinks.forEach(link => {
		const targetId = link.getAttribute('href').substring(1); // Remove the '#' symbol
		const target = document.getElementById(targetId);

		if (target) {
			observer.observe(target);
		}
	});
}